import { render, staticRenderFns } from "./NewMemory.vue?vue&type=template&id=5fbd40f9&scoped=true&"
import script from "./NewMemory.vue?vue&type=script&lang=js&"
export * from "./NewMemory.vue?vue&type=script&lang=js&"
import style0 from "./NewMemory.vue?vue&type=style&index=0&id=5fbd40f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd40f9",
  null
  
)

export default component.exports